// API functions

async function getData(partialUrl, options, code) {
  const endpoint = window.loyaltyProgram.endpoint;

  let completeUrl;
  if (partialUrl.endsWith("?")) {
    completeUrl = `${endpoint}${partialUrl}code=${code}`;
  } else {
    completeUrl = `${endpoint}${partialUrl}&code=${code}`;
  }

  try {
    showAll(SELECTORS.loader);

    const response = await fetch(completeUrl, options, code);
    const contentType = response.headers.get("content-type");

    if (!contentType || !contentType.includes("application/json")) {
      const errorElement = document.createElement("div");
      errorElement.classList.add("error");
      errorElement.innerHTML = MESSAGES.genericError;
      const sectionLoyalty = document.querySelector(".section.section-loyalty");
      sectionLoyalty.appendChild(errorElement);
      hideAll(SELECTORS.loader);
    }
    const data = await response.json();
    hideAll(SELECTORS.loader);
    return data;
  } catch (error) {
    console.error(error.message);
    hideAll(SELECTORS.loader);
    return null;
  }
}

async function fetchCart() {
  const partialUrl = `${Shopify.routes.root}cart.js`;
  const code = CODES.GetCartKeyX;
  const options = {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  };
  const response = await fetch(partialUrl, options, code);
  return response.json();
}

async function getCustomerData(phoneNumber) {
  const partialUrl = "GetCustomerInfoKeyX?phone=" + phoneNumber;
  const code = CODES.GetCustomerInfoKeyX;
  const options = {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  const result = await getData(partialUrl, options, code);
  if (!result || result.answerCode != 0) throw new Error("Error in customer data retrieval");
  return result.customerList;
}

async function updateCardMetafield(cardNumber, keyXCustomerId) {
  const customerId = window.loyaltyProgram.customerId;
  const partialUrl = "SaveNCardKeyX" + "?";
  const code = CODES.SaveNCardKeyX;
  const options = {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      cardNumber: cardNumber,
      customerId: `gid://shopify/Customer/` + customerId,
      keyXId: keyXCustomerId
    })
  };

  return await getData(partialUrl, options, code);
}

async function retrieveCardNumberInformation(cardNumber) {
  const partialUrl = "GetNCardKeyX?cardnumber=" + cardNumber;
  const code = CODES.GetNCardKeyX;
  const options = {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "ok"
    }
  };
  const result = await getData(partialUrl, options, code);
  if (!result || result.answerCode != 0) return null;
  return result;
}

async function verifyPhoneNumber(mobile) {
  const partialUrl = "CellphoneOtpGenerateKeyX" + "?";
  const code = CODES.CellphoneOtpGenerateKeyX;
  const options = {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      campaignid: 0,
      mobile
    })
  };

  return await getData(partialUrl, options, code);
}

async function verifyOTP(mobile, verificationcode) {
  const partialUrl = "CellphoneOtpVerifyKeyX" + "?";
  const code = CODES.CellphoneOtpVerifyKeyX;
  const options = {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      campaignid: 0,
      mobile,
      verificationcode
    })
  };

  const result = await getData(partialUrl, options, code);
  return result;
}

async function createNewCard(formFieldsValues) {
  const partialUrl = "CreateNewCardKeyX" + "?";
  const code = CODES.CreateNewCardKeyX;
  const fullPhoneNumber = getFullPhoneNumber();
  const options = {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      campaignid: 0,
      phone: fullPhoneNumber,
      firstName: formFieldsValues.firstName,
      lastName: formFieldsValues.lastName,
      date: formFieldsValues.date,
      gender: formFieldsValues.gender,
      dynamicField: formFieldsValues.isTermsAndConditionsChecked,
      usedforpromotions: formFieldsValues.usedforpromotions,
      usedforstatistics: formFieldsValues.usedforstatistics,
      email: window.loyaltyProgram.customerEmail
    })
  };

  const result = await getData(partialUrl, options, code);
  return result;
}

async function getNewOrderPoints(cartTotalValue) {
  const partialUrl =
    "GetProductPointsKeyX?productPrice=" + cartTotalValue + "&categoryId=" + window.loyaltyProgram.keyXCategoryId;
  const code = CODES.GetProductPointsKeyX;
  const options = {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  const result = await getData(partialUrl, options, code);
  return result;
}

async function getCouponData(cardNumber) {
  const partialUrl = "GetDiscountsKeyX?cardNumber=" + cardNumber + "&categoryId=" + window.loyaltyProgram.keyXCategoryId;
  const code = CODES.GetDiscountsKeyX;
  const options = {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  const result = await getData(partialUrl, options, code);
  return result;
}

async function generateCoupon(cardNumber, discountAmount, customerId) {
  const partialUrl = "CreateCoupon?cardNumber=" + cardNumber + "&locale=" + window.loyaltyProgram.locale;
  const code = CODES.CreateCoupon;
  const options = {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      discountAmount,
      customerId: `gid://shopify/Customer/` + customerId,
      email: window.loyaltyProgram.customerEmail
    })
  };
  const result = await getData(partialUrl, options, code);
  return result;
}


async function getCustomerInfo(){
  const keyXId = window.loyaltyProgram.keyXCustomerId;
  const partialUrl = "GetCustomerInfoKeyXById?customerId=" + keyXId;
  const code = CODES.GetCustomerInfoKeyXById;
  const options = {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "ok",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  const result = await getData(partialUrl, options, code);
  return result;
}